import layout from '@/components/common/layout';
import empList from '../views/empcontract/list';

export default [
    {
        path: '/empcontract',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "员工合同",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '10',// 父选项
                        child: 'employee_list',// 子选项
                    }
                },
                component: empList,
            },
        ]
    },
];
